import React from 'react';

const MediquoPatientBadge = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    className={className}
  >
    <path
      d="M34.5946 0H13.4054C6.00181 0 0 6.0018 0 13.4054V34.5946C0 41.9982 6.00181 48 13.4054 48H34.5946C41.9982 48 48 41.9982 48 34.5946V13.4054C48 6.0018 41.9982 0 34.5946 0Z"
      fill="#4A1EA7"
    />
    <path
      d="M36.4197 38.8348C36.212 38.8348 36.0303 38.7823 35.8746 38.743L29.7881 37.1305L29.5675 37.2354C27.6468 38.1662 25.5963 38.6381 23.5069 38.6381C22.5725 38.6381 21.6121 38.5464 20.6518 38.3628C16.9272 37.6418 13.579 35.3344 11.4766 32.0307C9.38717 28.727 8.68637 24.7023 9.59481 20.979C11.1651 14.411 16.7455 9.94048 23.4809 9.86182C24.4932 9.88804 25.3886 9.97981 26.2062 10.1371C30.7225 11.0679 34.4211 14.0046 36.3548 18.1866C38.2106 22.2114 38.1457 26.7868 36.1601 30.7591L36.0433 30.9819L36.1082 31.231C36.6273 33.0926 37.1334 34.9936 37.6525 36.9207C37.7693 37.3403 37.8342 37.8384 37.4838 38.3104C37.2373 38.6512 36.8479 38.8348 36.4197 38.8348ZM23.4679 12.4445C17.9395 12.5362 13.3583 16.207 12.0735 21.5821C11.3338 24.6236 11.9048 27.9273 13.6309 30.628C15.3569 33.3417 18.0952 35.2296 21.132 35.8195C21.9236 35.9768 22.7282 36.0555 23.4939 36.0555C25.3497 36.0555 27.1406 35.6097 28.8277 34.7183C29.1522 34.5609 29.4117 34.5085 29.6972 34.5085C29.84 34.5085 29.9827 34.5216 30.1255 34.5478L34.6936 35.754L34.3951 34.6658C34.0967 33.5908 33.8112 32.5289 33.5127 31.467C33.3699 30.8377 33.4348 30.3527 33.7073 29.8807C35.4853 26.5508 35.6021 22.6833 34.0188 19.2616C32.4355 15.8268 29.3987 13.4146 25.7001 12.6542C25.0382 12.5231 24.2726 12.4445 23.4809 12.4314H23.4679V12.4445Z"
      fill="white"
      stroke="white"
      strokeWidth="0.586336"
    />
    <path
      d="M27.1877 25.5652H24.6369V28.1991C24.6369 28.9274 24.0655 29.5161 23.3615 29.5161C22.6562 29.5161 22.086 28.9274 22.086 28.1991V25.5652H19.5352C18.8299 25.5652 18.2598 24.9766 18.2598 24.2483C18.2598 23.5213 18.8299 22.9313 19.5352 22.9313H22.086V20.2974C22.086 19.5705 22.6562 18.9805 23.3615 18.9805C24.0655 18.9805 24.6369 19.5705 24.6369 20.2974V22.9313H27.1877C27.8918 22.9313 28.4632 23.5213 28.4632 24.2483C28.4632 24.9766 27.8918 25.5652 27.1877 25.5652Z"
      fill="white"
      stroke="white"
      strokeWidth="0.586336"
    />
  </svg>
);

export default MediquoPatientBadge;
